import { toast } from 'react-toastify';
import NotifyComponent from 'shared/ui/notify-component';

/**
 * Toast wrapper that renders title + text + custom message using
 * the shared NotifyComponent body.
 *
 * @param {string} title - Toast heading
 * @param {unknown} res - Error/response object; message is extracted
 * @param {'error'|'success'|'warning'} [type='error'] - Toast variant
 * @param {string} [customMsg] - Extra contextual message below the body
 */
export const handleCustomMessage = (title, res, type = 'error', customMsg) => {
  const props = {
    data: {
      title,
      text: res?.response?.data?.errors?.[0]?.message ?? res?.message ?? '',
      customMsg,
    },
  };
  if (type === 'error') toast.error(NotifyComponent, props);
  else toast.success(NotifyComponent, props);
};
